import { HttpService, PrintReportService, PrintReportProvider } from '@lk/api'

export const makePrintReportService = (http: HttpService, baseUrl: string) =>
  new PrintReportService(new PrintReportProvider(http, baseUrl))
